/**
 * SkeletonCard component
 * Skeleton loader for card layouts
 */

import { Skeleton } from './Skeleton';

interface SkeletonCardProps {
  hasImage?: boolean;
  lines?: number;
}

/**
 * Card skeleton loader
 * Shows placeholder for card content
 *
 * @example
 * ```tsx
 * <SkeletonCard hasImage lines={3} />
 * ```
 */
export function SkeletonCard({ hasImage = false, lines = 2 }: SkeletonCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-md p-4 space-y-3">
      {hasImage && <Skeleton className="h-48 w-full" />}
      <Skeleton className="h-6 w-3/4" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className="h-4 w-full" />
      ))}
    </div>
  );
}
